var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('card',{attrs:{"flat":""}},[_c('card-title',[_vm._v("I am the ICE content")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }